module.exports = __webpack_public_path__ + "static/media/medical-history.03f73b9c.svg";